import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  button: {
    marginTop: 16,
  },
  checkbox: {
    alignSelf: 'center',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  compromisedPasswordText: {
    alignSelf: 'center',
    color: 'red',
    flex: 1,
    fontSize: 12,
    justifyContent: 'center',
    marginBottom: 4,
    marginLeft: 8,
  },
  dateOfBirthContainer: {
    // Bug: dropdowns fall behind other content in react-navigation draw menu components #248
    // https://github.com/hossein-zare/react-native-dropdown-picker/issues/248
    zIndex: 1000,
  },
  dateOfBirthInput: {
    width: '100%',
    paddingHorizontal: 8,
  },
  errorMessage: {
    margin: 5,
    fontSize: 12,
    color: 'red',
    paddingHorizontal: 10,
  },
  formElement: {
    marginTop: 8,
  },
  label: {
    paddingHorizontal: 10,
    color: 'rgb(134, 147, 158)',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
});
